import { router } from '@inertiajs/vue3';
import { toast } from 'vue-sonner';

let sessionExpiredHandled = false;

export function initializeHttpErrorHandling() {
    router.on('httpException', (event) => {
        const response = event.detail?.response;

        if (response?.status === 419) {
            event.preventDefault();

            if (sessionExpiredHandled) {
                return;
            }

            sessionExpiredHandled = true;

            toast.error('Je sessie is verlopen. De pagina wordt opnieuw geladen…');

            setTimeout(() => {
                window.location.reload();
            }, 2000);

            return;
        }

        const responseBody = response?.data;

        if (!responseBody?.error) {
            return;
        }

        event.preventDefault();

        toast.error(responseBody.error);
    });
}
